import React, { useState, useImperativeHandle, forwardRef } from 'react'
import Button from '@material-ui/core/Button';
import Api from '../../../__helpers/api';
import { useAuthDataContext } from '../../../__providers/AuthProvider';

//images
import keyIcon from '../../../assets/images/profile/key-small.png';
import loader from '../../../assets/images/contacts/loader.svg';
import closeIcon from '../../../assets/images/profile/close-icon.png';
import leftArrowWhiteIcon from '../../../assets/images/profile/left-arrow-white.png'
import activateIcon from '../../../assets/images/profile/activate-icon.png'
import closeWhiteIcon from '../../../assets/images/profile/code-activation/icons/close.png'
import keySmallIcon from '../../../assets/images/profile/code-activation/icons/key-small.png'

//modals
import Success from '../../modals/Success';
import Error from '../../modals/Error';

function Code(props, ref) {
    const auth = useAuthDataContext();

    const [modal, setModal] = useState({
        overlay: false,
        modal: false,
        firstPart: '',
        secondPart: '',
        loading: false,
        showOverlay: false,
        successOverlay: false,
        successModal: false,
        mainSuccessMessage: 'Всички теми са успешно активирани!',
        secondarySuccessMessage: 'След успешното активиране на темите, може да продължищ с обучението си.',
        errorOverlay: false,
        errorModal: false,
        mainErrorMessage: 'Невалиден код!',
        secondaryErrorMessage: 'Моля, провери въведения код.',
    })

    useImperativeHandle(ref, () => ({
        open: () => handleOpen(),
        close: () => handleClose(),
    }))

    const handleOpen = () => {

        document.querySelector('body').style.overflow = 'hidden'

        setModal(prev => ({
            ...prev,
            overlay: true,
        }))
        setTimeout(() => {
            setModal(prev => ({
                ...prev,
                modal: true,
            }))

            document.getElementById('firstHalf').focus()
        }, 50)
    }

    const handleClose = () => {
        props.hideCodeModal()

        document.querySelector('body').style.overflow = 'initial'

        setModal(prev => ({
            ...prev,
            modal: false,
        }))

        setTimeout(() => {
            setModal(prev => ({
                ...prev,
                overlay: false,
            }))
            document.getElementById('firstHalf').value = ''
            document.getElementById('secondHalf').value = ''
        }, 100)
    }

    const handleCloseSuccess = () => {
        handleClose()
        setModal(prev => ({
            ...prev,
            successModal: false,
        }))

        setTimeout(() => {
            setModal(prev => ({
                ...prev,
                successOverlay: false,
            }))
            window.location.reload()
        }, 100)
    }

    const handleFirstHalf = e => {
        let firstPart = e.target.value.toUpperCase()
        if (modal.firstPart.length == 4) {
            document.getElementById('secondHalf').focus()
        }
        setModal(prev => {
            return {
                ...prev,
                firstPart: firstPart
            }
        })
    }
    const handleSecondHalf = e => {
        let secondPart = e.target.value.toUpperCase()

        setModal(prev => {
            return {
                ...prev,
                secondPart: secondPart.toUpperCase()
            }
        })
    }

    const handleActivation = () => {
        setModal(prev => {
            return {
                ...prev,
                loading: true
            }
        })
        let activationUrl = 'student/profile/activate';
        Api.post(activationUrl, {
            key: `${modal.firstPart}-${modal.secondPart}`
        })
            .then(res => {
                auth.refresh()
                setModal(prev => {
                    return {
                        ...prev,
                        successOverlay: true,
                        loading: false
                    }
                })
                setTimeout(() => {
                    setModal(prev => {
                        return {
                            ...prev,
                            successModal: true
                        }
                    })
                }, 50);
            })
            .catch(err => {
                setModal(prev => {
                    return {
                        ...prev,
                        errorOverlay: true,
                        mainErrorMessage: prev.secondPart.length == 0 && prev.firstPart.length == 0 ? 'Моля, въведи код за активация' : 'Невалиден код!',
                        secondaryErrorMessage: prev.secondPart.length == 0 && prev.firstPart.length == 0 ? 'За да активираш профила си трябва да въведеш код.' : 'Моля, проверете въведения код.',
                        loading: false
                    }
                })
                setTimeout(() => {
                    setModal(prev => {
                        return {
                            ...prev,
                            errorModal: true
                        }
                    })
                }, 50);
            })
    }

    const handleCloseError = () => {
        setModal(prev => {
            return {
                ...prev,
                errorModal: false
            }
        })
        setTimeout(() => {
            setModal(prev => {
                return {
                    ...prev,
                    errorOverlay: false
                }
            })
        }, 100);
    }



    return (
        <>
            <div id="overlay" className={`code-overlay ${modal.overlay ? 'visible' : ''}`}>
                <div className={`activation-popup ${modal.modal ? 'show' : ''}`}>
                    <img
                        src={closeWhiteIcon}
                        alt="close"
                        onClick={handleClose}
                        className="close-activation"
                    />
                    <Button onClick={() => props.handleBack()} className="btn-back">
                        <img src={leftArrowWhiteIcon} alt="Назад" />
                        Назад
                    </Button>
                    <img src={activateIcon} alt="Активиране" className="main-icon" />
                    <h2>
                        Активирай всички теми
                </h2>
                    <p>
                        За да активираш всички теми в Мултимедийно Интерактивно учебно помагало Авто Обучение е нужно да въведеш код за активация.
                    </p>
                    <div className="fields">
                        <input type="text" value={modal.firstPart} maxLength="5" id="firstHalf" onChange={handleFirstHalf} placeholder="XXXXX" />
                        -
                        <input type="text" value={modal.secondPart} maxLength="6" id="secondHalf" onChange={handleSecondHalf} placeholder="XXXXX" />
                    </div>
                    {modal.loading ?
                        <img src={loader} alt="loader" className="loader" />
                        :
                        <Button onClick={handleActivation} className="btn-activate">
                            Активирай
                        </Button>
                    }
                    <div className="footer">
                        <img src={keySmallIcon} alt="key" />
                        Вижте начини за активация на Авто Обучение от
                        <span onClick={() => props.handleBack()}>
                            ТУК
                        </span>
                    </div>
                </div>
            </div>
            <Success
                blur={modal.successOverlay}
                popup={modal.successModal}
                acceptCallback={handleCloseSuccess}
                mainMessage={modal.mainSuccessMessage}
                secondaryMessage={modal.secondarySuccessMessage}
            />
            <Error
                blur={modal.errorOverlay}
                popup={modal.errorModal}
                acceptCallback={handleCloseError}
                mainMessage={modal.mainErrorMessage}
                secondaryMessage={modal.secondaryErrorMessage}
            />
        </>
    )
}


export default forwardRef(Code)